import axios from "axios";
import config from "../configurations/config";
import { ACCOUNTS, ACCOUNT_USERS, ID_TOKEN, SESSION_EXPIRED, USERS } from "./Constants";

export async function logout() {
  sessionStorage.clear();
  window.location.href = config.auth.URL + "logout";
};

export async function fetchAllAccountData() {
  const response = await axios
    .get(config.apiGateway.URL + ACCOUNTS, {
      method: "Get",
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN),
      },
    })
    .then((response) => {
      return response.data.accounts;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response;

};

export async function fetchAccountDataWithIntgAccId(integrationAcctId) {
  const response = await axios
    .get(config.apiGateway.URL + "accounts/" + integrationAcctId, {
      method: 'Get',
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN)
      },
    }).then((response) => {
      return response.data.accounts;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.status === 403 || error.response.status === 400 || error.response.status === 401) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response;
}
export async function fetchNotificationDataWithIntgAccId(integrationAcctId) {
  const response = await axios
    .get(config.apiGateway.URL + "accounts/notification/" + integrationAcctId, {
      method: 'Get',
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN)
      },
    }).then((response) => {
      return response.data.accounts;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.status === 403 || error.response.status === 400 || error.response.status === 401) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response;
}
export async function createAccountAPI(newData) {
  const response = await fetch(config.apiGateway.URL + USERS, {
    method: "POST",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify(newData),
  }).then((response) => response.json())
    .then((data) => { return data })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response
}
export async function createNewAccout(newData) {
  await fetch(config.apiGateway.URL + ACCOUNTS, {
    method: "POST",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify(newData),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
}
export async function editAccountdata(row) {
  await fetch(config.apiGateway.URL + ACCOUNTS, {
    method: "PUT",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify({ clientName: row.clientName, clientId: row.clientUserId, integrationAcctId: row.integrationAcctId, description: row.description, contactEmail: row.contactEmail, organization: row.organization })
  }).then(response =>
    response.json()
  ).then(data => {
    return data
  }).catch((error) => {
    if (error.response !== undefined) {
      if (
        error.response.status === 403 ||
        error.response.status === 400 ||
        error.response.status === 401
      ) {
        alert(SESSION_EXPIRED);
        logout();
      }
    }
  });
}
export async function deleteAccount(integrationAcctId) {
  await fetch(config.apiGateway.URL + "accounts/" + integrationAcctId, {
    method: "DELETE",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
  }).then(response => {
    return response;
  }
  ).catch((error) => {
    if (error.response !== undefined) {
      if (
        error.response.status === 403 ||
        error.response.status === 400 ||
        error.response.status === 401
      ) {
        alert(SESSION_EXPIRED);
        logout();
      }
    }
  });
}
export async function deleteAccountMapping(systemIdInfo) {
  await fetch(`${config.apiGateway.URL}accounts/accountmapping/${systemIdInfo}`, {
    method: "DELETE",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
  }).then(response => {
    return response
  }).catch((error) => {
    if (error.response !== undefined) {
      if (
        error.response.status === 403 ||
        error.response.status === 400 ||
        error.response.status === 401
      ) {
        alert(SESSION_EXPIRED);
        logout();
      }
    }
  });
}
export async function deleteNotificationMapping(integrationAcctId, notificationType) {
  await fetch(`${config.apiGateway.URL}account/${integrationAcctId}/notification/${notificationType}`, {
    method: "DELETE",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
  }).then(response => {
    return response
  }).catch((error) => {
    if (error.response !== undefined) {
      if (
        error.response.status === 403 ||
        error.response.status === 400 ||
        error.response.status === 401
      ) {
        alert(SESSION_EXPIRED);
        logout();
      }
    }
  });
}
export async function createUserAPI(newData) {
  const response = await fetch(config.apiGateway.URL + ACCOUNT_USERS, {
    method: "POST",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify(newData),
  }).then((response) => response.json())
    .then((data) => { return data })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response
}
export async function fetchAllUserData() {
  const response = await axios
    .get(config.apiGateway.URL + ACCOUNT_USERS, {
      method: "GET",
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN),
      },
    })
    .then((response) => {
      return response.data.account;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response;

};
export async function editUserdata(row) {
const response =  await fetch(config.apiGateway.URL + USERS, {
    method: "PUT",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify({
      firstName: row.firstName,
      lastName: row.lastName,
      email: row.email,
      userId: row.userId,
    }),
}).then((response) => response.json())
.then((data) => { return data })
.catch((error) => {
  if (error.response !== undefined) {
    if (
      error.response.status === 403 ||
      error.response.status === 400 ||
      error.response.status === 401
    ) {
      alert(SESSION_EXPIRED);
      logout();
    }
  }
});
return response;
}
export async function deleteUser(userId) {
  await fetch(config.apiGateway.URL + "users?hardDelete=true", {
    method: "DELETE",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify({
      userId: userId
    }),
  }).then(response => {
    return response;
  }
  ).catch((error) => {
    if (error.response !== undefined) {
      if (
        error.response.status === 403 ||
        error.response.status === 400 ||
        error.response.status === 401
      ) {
        alert(SESSION_EXPIRED);
        logout();
      }
    }
  });
}
export async function fetchAllSalesforceMappingsData() {
  const response = await axios
    .get(config.apiGateway.URL + "accounts/salesforce", {
      method: "GET",
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN),
      },
    })
    .then((response) => {
      return response.data.accounts;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response;
};
export async function fetchAllSalesforceMappingsDataById(id) {
  const response = await axios
    .get(config.apiGateway.URL + `accounts/salesforce/${id}`, {
      method: "GET",
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN),
      },
    })
    .then((response) => {
      return response.data.accounts;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response;
};

export async function saveAllSalesforceMappings(newData) {
  await fetch(config.apiGateway.URL + "accounts/salesforce", {
    method: "POST",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify(newData),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
}

export async function updateSalesforceMapping(newData) {
  await fetch(config.apiGateway.URL + "accounts/salesforce", {
    method: "PUT",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify(newData),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
}
export async function fetchAllCentralKnovioMappingData() {
  const response = await axios
    .get(config.apiGateway.URL + 'account/oecknoviomapping', {
      method: "GET",
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN),
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response;

};
export async function createKnovioAccountAPI(newAccountData) {
  const response = await fetch(config.apiGateway.URL + 'account/oecknoviomapping', {
    method: "POST",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify({ accountName: newAccountData.accountName, accountNumber: newAccountData.accountNumber, knovioAccountId: newAccountData.centralData[0].knovioCreationAccountId }),
  }).then((response) => response.json())
    .then((data) => { return data })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response
}
export async function updateKnovioAccountAPI(newAccountData) {
  const response = await fetch(config.apiGateway.URL + 'account/oecknoviomapping', {
    method: "PUT",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: JSON.stringify(newAccountData),
  }).then((response) => response.json())
    .then((data) => { return data })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response
}
export async function manageKnovioAccountAPI(newAccountData) {
  const response = await fetch(config.apiGateway.URL + 'account/oecknoviomapping/manage', {
    method: "PUT",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
    body: newAccountData,
  }).then((response) => response.json())
    .then((data) => { return data })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response
}
export async function deleteAccountmappings(oecAccountNumber) {
  await fetch(`${config.apiGateway.URL}account/oecknoviomapping/${oecAccountNumber}`, {
    method: "DELETE",
    headers: { "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN) },
  }).then(response => {
    return response
  }).catch((error) => {
    if (error.response !== undefined) {
      if (
        error.response.status === 403 ||
        error.response.status === 400 ||
        error.response.status === 401
      ) {
        alert(SESSION_EXPIRED);
        logout();
      }
    }
  });
}

export async function fetchOneWayAttendeeRegistrationSecrets(secretName) {
  const response = await axios
    .get(config.apiGateway.URL + `secrets?secretName=${secretName}`, {
      method: "GET",
      headers: {
        "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN),
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (
          error.response.status === 403 ||
          error.response.status === 400 ||
          error.response.status === 401
        ) {
          alert(SESSION_EXPIRED);
          logout();
        }
      }
    });
  return response.data;
};

export async function uploadTeamsData(jsonData) {
  try {
    const response = await axios.post(
      config.apiGateway.URL + "criteria/replace",
      { replaceData: jsonData },
      {
        headers: {
          "X-OEX-Int-Authorization": sessionStorage.getItem(ID_TOKEN),
          "Content-Type": "application/json",
        },
      }
    );
    return { success: true, data: response.data };
  } catch (error) {
      const status = error.response.status;
      const payloadMessage =
        error.response.data?.message ||
        error.response.data?.error ||
        "Something went wrong";
      if (status === 401 || status === 403) {
        alert(SESSION_EXPIRED);
        logout();
        return { success: false, message: SESSION_EXPIRED };
      }
      const emailsNotFound = error.response.data?.emailsNotFound;
      return { success: false, message: payloadMessage, emailsNotFound };
  }
}